import React, { memo } from "react";
import { InformationText } from "../information-text/information-text";
import styled from "styled-components";

interface IProps {
  error: string;
  status?: string;
}

const ErrorMessageWrapper = styled.div`
  width: 100%;
`;

const ErrorMessageView = (props: IProps) => {
  return (
    <ErrorMessageWrapper>
      <InformationText
        data-test="error-message-view"
        text={props.error}
        status={props.status}
      />
    </ErrorMessageWrapper>
  );
};

export const ErrorMessage = memo(ErrorMessageView);
